/**
 * Zoom controls for the map
 * @param {Object} props
 * @param {React.RefObject} props.mapRef - Reference to MarketMapBase
 */
export const ZoomControls = ({ mapRef }) => {
    const handleZoomIn = () => mapRef.current?.zoomIn();
    const handleZoomOut = () => mapRef.current?.zoomOut();

    return (
        <div className="w-[38px] h-[64px] flex flex-col gap-0 bg-cm-p-surface-container border border-cm-p-outline-variation rounded-[64px] items-center">
            <button onClick={handleZoomIn} className="w-8 h-8 flex items-center justify-center" title="Zoom in">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 3V13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                    <path d="M3 8H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
            </button>
            <button onClick={handleZoomOut} className="w-8 h-8 flex items-center justify-center" title="Zoom out">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 8H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
            </button>
        </div>
    );
};
